import React from 'react';
import { FP610, FP611 } from '../../../services/pwp254Api';
import { fmt1, fmtRate } from '../helpers';

interface Tab2Props {
  formData: Partial<FP610>;
  details: Partial<FP611>[];
  selectedRow: number;
  isEditing: boolean;
  setSelectedRow: (idx: number) => void;
  setDetailField: (key: keyof FP611, value: FP611[keyof FP611]) => void;
  setRateField: (key: keyof FP610, value: number) => void;
  addDetailRow: () => void;
  deleteDetailRow: () => void;
}

const parseNum = (v: string): number => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

const Tab2Detail: React.FC<Tab2Props> = React.memo(({
  formData, details, selectedRow, isEditing,
  setSelectedRow, setDetailField, setRateField,
  addDetailRow, deleteDetailRow,
}) => {
  const sel = details[selectedRow] as Partial<FP611> | undefined;

  return (
    <div className="tab-pane active">
      {/* Rate area (top) */}
      <div className="rate-bar">
        <span className="rate-title">單位換算率</span>
        <div className="rate-fields">
          <label>MTS</label>
          <input type="text" value={fmtRate(formData.fp610_22)} disabled={!isEditing}
            onChange={e => setRateField('fp610_22', parseNum(e.target.value))} style={{ width: 110 }} />
          <label>N.W.</label>
          <input type="text" value={fmtRate(formData.fp610_23)} disabled={!isEditing}
            onChange={e => setRateField('fp610_23', parseNum(e.target.value))} style={{ width: 110 }} />
          <label>G.W.</label>
          <input type="text" value={fmtRate(formData.fp610_24)} disabled={!isEditing}
            onChange={e => setRateField('fp610_24', parseNum(e.target.value))} style={{ width: 110 }} />
        </div>
      </div>

      {/* Grid */}
      <div className="table-wrapper">
        <div className="table-toolbar">
          <div className="left">
            <button className="btn btn-sm" disabled={!isEditing} onClick={addDetailRow}>明細新增</button>
            <button className="btn btn-sm btn-danger" disabled={!isEditing || details.length === 0} onClick={deleteDetailRow}>明細刪除</button>
          </div>
          <div className="right">
            <span>總項數: {formData.fp610_16 || 0}</span>
          </div>
        </div>
        <div className="table-scroll">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 40 }}>項數</th>
                <th style={{ width: 50 }}>R/NO</th>
                <th style={{ width: 100 }}>COLOR</th>
                <th>碼數1 / 補1 / 缸1</th>
                <th>碼數2 / 補2 / 缸2</th>
                <th>碼數3 / 補3 / 缸3</th>
                <th>碼數4 / 補4 / 缸4</th>
                <th className="num" style={{ width: 70 }}>YDS</th>
                <th className="num" style={{ width: 70 }}>MTS</th>
                <th className="num" style={{ width: 70 }}>G.W.</th>
                <th className="num" style={{ width: 70 }}>N.W.</th>
              </tr>
            </thead>
            <tbody>
              {details.map((d, i) => (
                <tr key={i} className={i === selectedRow ? 'selected' : ''}
                  onClick={() => setSelectedRow(i)}>
                  <td>{d.fp611_02}</td>
                  <td>
                    <input type="text" value={d.fp611_11 || ''} disabled={!isEditing || i !== selectedRow}
                      onChange={e => { setSelectedRow(i); setDetailField('fp611_11', e.target.value); }}
                      maxLength={4} style={{ width: 45 }} />
                  </td>
                  <td>
                    <input type="text" value={d.fp611_121 || ''} disabled={!isEditing || i !== selectedRow}
                      onChange={e => { setSelectedRow(i); setDetailField('fp611_121', e.target.value); }}
                      maxLength={30} style={{ width: 95 }} />
                  </td>
                  <td>
                    <div className="grid-cell-group">
                      <input type="number" value={d.fp611_21 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_21', parseNum(e.target.value)); }}
                        step="0.1" placeholder="碼" style={{ width: 70 }} />
                      <input type="number" value={d.fp611_51 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_51', parseNum(e.target.value)); }}
                        step="0.1" placeholder="補" style={{ width: 55 }} />
                      <input type="text" value={d.fp611_31 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_31', e.target.value); }}
                        maxLength={10} placeholder="缸" style={{ width: 70 }} />
                    </div>
                  </td>
                  <td>
                    <div className="grid-cell-group">
                      <input type="number" value={d.fp611_22 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_22', parseNum(e.target.value)); }}
                        step="0.1" placeholder="碼" style={{ width: 70 }} />
                      <input type="number" value={d.fp611_52 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_52', parseNum(e.target.value)); }}
                        step="0.1" placeholder="補" style={{ width: 55 }} />
                      <input type="text" value={d.fp611_32 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_32', e.target.value); }}
                        maxLength={10} placeholder="缸" style={{ width: 70 }} />
                    </div>
                  </td>
                  <td>
                    <div className="grid-cell-group">
                      <input type="number" value={d.fp611_23 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_23', parseNum(e.target.value)); }}
                        step="0.1" placeholder="碼" style={{ width: 70 }} />
                      <input type="number" value={d.fp611_53 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_53', parseNum(e.target.value)); }}
                        step="0.1" placeholder="補" style={{ width: 55 }} />
                      <input type="text" value={d.fp611_33 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_33', e.target.value); }}
                        maxLength={10} placeholder="缸" style={{ width: 70 }} />
                    </div>
                  </td>
                  <td>
                    <div className="grid-cell-group">
                      <input type="number" value={d.fp611_24 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_24', parseNum(e.target.value)); }}
                        step="0.1" placeholder="碼" style={{ width: 70 }} />
                      <input type="number" value={d.fp611_54 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_54', parseNum(e.target.value)); }}
                        step="0.1" placeholder="補" style={{ width: 55 }} />
                      <input type="text" value={d.fp611_34 || ''} disabled={!isEditing || i !== selectedRow}
                        onChange={e => { setSelectedRow(i); setDetailField('fp611_34', e.target.value); }}
                        maxLength={10} placeholder="缸" style={{ width: 70 }} />
                    </div>
                  </td>
                  <td className="num">{fmt1(d.fp611_41)}</td>
                  <td className="num">{fmt1(d.fp611_42)}</td>
                  <td className="num">{fmt1(d.fp611_43)}</td>
                  <td className="num">{fmt1(d.fp611_44)}</td>
                </tr>
              ))}
              {details.length === 0 && (
                <tr><td colSpan={11} style={{ textAlign: 'center', color: '#999', padding: 20 }}>無明細資料</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Bottom summary: single row YDS/MTS/GW/NW */}
      <div className="detail-summary">
        <span className="rate-title">單筆</span>
        <div className="rate-fields">
          <label>YDS</label>
          <input type="text" value={fmt1(sel?.fp611_41)} readOnly disabled style={{ width: 90 }} />
          <label>MTS</label>
          <input type="text" value={fmt1(sel?.fp611_42)} readOnly disabled style={{ width: 90 }} />
          <label>G.W.</label>
          <input type="text" value={fmt1(sel?.fp611_43)} readOnly disabled style={{ width: 90 }} />
          <label>N.W.</label>
          <input type="text" value={fmt1(sel?.fp611_44)} readOnly disabled style={{ width: 90 }} />
        </div>
      </div>
    </div>
  );
});

Tab2Detail.displayName = 'Tab2Detail';
export default Tab2Detail;
